import React from 'react';
import { makeClassName } from '@siteless/util';
import { IconPropsType } from '../util/types';

const LogOutIcon = ({ className, ...rest }: IconPropsType) => (
  <svg
    className={makeClassName('LogOutIcon', className)}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    {...rest}
  >
    <path
      d="M9,22H5c-1.65,0-3-1.35-3-3V5c0-1.65,1.35-3,3-3h4c0.55,0,1,0.45,1,1S9.55,4,9,4H5C4.45,4,4,4.45,4,5v14c0,0.55,0.45,1,1,1
	h4c0.55,0,1,0.45,1,1S9.55,22,9,22z"
    />
    <path
      d="M16,18c-0.26,0-0.51-0.1-0.71-0.29c-0.39-0.39-0.39-1.02,0-1.41L19.59,12l-4.29-4.29c-0.39-0.39-0.39-1.02,0-1.41
	s1.02-0.39,1.41,0l5,5c0.39,0.39,0.39,1.02,0,1.41l-5,5C16.51,17.9,16.26,18,16,18z"
    />
    <path d="M21,13H9c-0.55,0-1-0.45-1-1s0.45-1,1-1h12c0.55,0,1,0.45,1,1S21.55,13,21,13z" />
  </svg>
);

export default LogOutIcon;
